'use strict';

var React = require('react');

var SvgCircleChevronUpMinor = function SvgCircleChevronUpMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-4.293 1.707a1 1 0 0 1-1.414 0l-2.293-2.293-2.293 2.293a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414z"
  }));
};

exports.SvgCircleChevronUpMinor = SvgCircleChevronUpMinor;
